// 根据公司code和供应商code的来显示和隐藏表单字段
import {
  COMPANY_CODE1,
  COMPANY_CODE2,
  INTERNAL_SETTLEMENT,
  WITHOUT_SETTLEMENT,
  DROP_OFF_PERSON,
} from '@/constants';
export default {
  data() {
    return {
      // 页面一进来就要隐藏的字段
      hiddenList: [
        'identityNo',
        'bankAccount',
        // 'customerName',
        'generateNo',
        // 'generateSalesCompanyName',
        // 'generateSalesDepartmentName',
        // 'recyclingCompanyFileNo',
        'recyclingCompanyName',
        // 'platformCompanyFileNo',
        'platformCompanyName',
        'mark',
      ], // 需要隐藏的字段
      // 是否生成销售协议合同的字段
      generateField: [
        // 'customerName',
        'generateNo',
        // 'generateSalesCompanyName',
        // 'generateSalesDepartmentName',
        // 'recyclingCompanyFileNo',
        'recyclingCompanyName',
        // 'platformCompanyFileNo',
        'platformCompanyName',
        'mark',
      ],
      isCreateStatus: false,
      // 是否引用生成采购合同或协议
      isDisabledGenerateSales: true,
    };
  },
  mounted() {
    if (this.$route.query.isEdit == 'false' || !this.$route.query.isEdit) {
      this.isCreateStatus = true;
    } else {
      this.isCreateStatus = false;
    }
  },
  methods: {
    /**
     * 根据公司和供应商来判断表单那些字段要隐藏
     * @param {*} companyCode 公司的code
     * @param {*} supplierType 当前供应商类型
     * @param {*} isHiddenGenerateField  是否要生成销售.协议
     */
    _hiddenFormFieldByCompanyCodeAndSupplierCode(
      companyCode,
      supplierType,
      isHiddenGenerateField = false
    ) {
      console.log(
        companyCode,
        supplierType,
        '开始判断',
        COMPANY_CODE1,
        COMPANY_CODE2,
        isHiddenGenerateField,
        COMPANY_CODE2.includes(companyCode)
      );
      this.isShowOverdueInterestTab = false;
      if (COMPANY_CODE1.includes(companyCode)) {
        // 如果是城矿公司的时候
        if (supplierType == INTERNAL_SETTLEMENT && this.fileType == 'agreement') {
          console.log('城矿公司->内部协议表单');

          const baseFieldList = [
            'contractTotalAmount',
            'purchaseQuantity',
            'isDefault',
            'contractSalesmanNo',
            'externalContractNo',
            'replyInvoiceDate',
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'creditPercent',
            'lastestPayMoneyDay',
            'lastestReceiveProductDay',
            'isPrepay',
            'creditAmount',
            'receiptMethod',

            'businessType',
            'identityNo',
            'bankAccount',
            'performanceBondPayMethodCode',
            'performanceBond',
            'warrantyClause',
            'overShippedPercentage',
            'shortShippedPercentage',
          ];
          // 协议的时候内部结算公司
          if (isHiddenGenerateField) {
            this.hiddenList = [
              ...baseFieldList,
              ...this.generateField,
              'isFixedPrice',
              // 'businessType',
              // 'warrantyClause',
              // 'performanceBond',
              // 'performanceBondPayMethodCode',
              // 'shortShippedPercentage',
              // 'overShippedPercentage',
            ];
          } else {
            this.hiddenList = baseFieldList;
          }
          this.isDisabledGenerateSales = false;
          // 如果是创建的时候默认勾选协议,否则要根据接口判断
          if (this.isCreateStatus) {
            this.isCreateStatus = false;
            this.baseFormData = {
              ...this.baseFormData,
              isGenerateSales: this.baseFormData.isRelatedParty == 'Y' ? true : false,
            };
          }
        } else if (supplierType == WITHOUT_SETTLEMENT && this.fileType == 'agreement') {
          console.log('城矿公司->外部协议表单');
          // 协议的时候外部结算公司
          this.hiddenList = [
            'contractTotalAmount',
            'purchaseQuantity',
            'overShippedPercentage',
            'shortShippedPercentage',
            'isDefault',
            'externalContractNo',
            'replyInvoiceDate',
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'creditPercent',
            'lastestPayMoneyDay',
            'lastestReceiveProductDay',
            'businessType',
            'isPrepay',
            'creditAmount',
            'receiptMethod',
            'warrantyClause',
            'performanceBond',
            'performanceBondPayMethodCode',
            'shortShippedPercentage',
            'overShippedPercentage',
            // 'customerName',
            'contractName',
            // 'generateSalesCompanyName',
            // 'generateSalesDepartmentName',
            // 'recyclingCompanyFileNo',
            'recyclingCompanyName',
            // 'platformCompanyFileNo',
            'platformCompanyName',
            'mark',
            'identityNo',
            'bankAccount',
            'generateNo',
          ];
          this.isDisabledGenerateSales = true;
        } else if (supplierType == INTERNAL_SETTLEMENT && this.fileType == 'contract') {
          console.log('城矿公司->内部结算公司-表单');
          // 合同的时候内部结算公司
          const baseFieldList = [
            'isDefault',
            'replyInvoiceDate',
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'creditPercent',
            'lastestPayMoneyDay',
            'lastestReceiveProductDay',
          ];
          if (isHiddenGenerateField) {
            this.hiddenList = [
              ...baseFieldList,
              ...this.generateField,
              'businessType',
              'isFixedPrice',
              'performanceBondPayMethodCode',
              'performanceBond',
              'warrantyClause',
              'overShippedPercentage',
              'shortShippedPercentage',
            ];
          } else {
            this.hiddenList = baseFieldList;
          }
          // 创建的时候默认勾选是否生成销售合同
          if (this.isCreateStatus) {
            this.isCreateStatus = false;
            this.baseFormData = {
              ...this.baseFormData,
              isGenerateSales: this.baseFormData.isRelatedParty == 'Y' ? true : false,
            };
          }
          this.isShowOverdueInterestTab = true;
          this.isDisabledGenerateSales = false;
        } else if (supplierType == WITHOUT_SETTLEMENT && this.fileType == 'contract') {
          console.log('城矿公司->外部结算公司表单-表单');
          // 合同的时候外部结算公司
          this.hiddenList = [
            'warrantyClause',
            'performanceBond',
            'performanceBondPayMethodCode',
            // 'customerName',
            'contractName',
            // 'generateSalesCompanyName',
            // 'generateSalesDepartmentName',
            // 'recyclingCompanyFileNo',
            'recyclingCompanyName',
            // 'platformCompanyFileNo',
            'platformCompanyName',
            'mark',
            'identityNo',
            'bankAccount',
            'generateNo',
          ];
          this.isDisabledGenerateSales = true;
        } else if (supplierType == DROP_OFF_PERSON && this.fileType == 'contract') {
          console.log('城矿公司->合同投送人表单');
          // 协议的时候投送人
          this.hiddenList = [
            'purchaseQuantity',
            'overShippedPercentage',
            'shortShippedPercentage',
            'isDefault',
            'contractSalesmanNo',
            'externalContractNo',
            'replyInvoiceDate',
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'creditPercent',
            'lastestPayMoneyDay',
            'lastestReceiveProductDay',
            'businessType',
            'isPrepay',
            'creditAmount',
            'isFixedPrice',
            'pricingRule',
            'receiptMethod',
            'warrantyClause',
            'performanceBond',
            'performanceBondPayMethodCode',
            'shortShippedPercentage',
            'overShippedPercentage',
            'platformCompanyName',
            // 'platformCompanyFileNo',
            'recyclingCompanyName',
            // 'recyclingCompanyFileNo',
            // 'generateSalesCompanyName',
            // 'generateSalesDepartmentName',
            'contractName',
            // 'customerName',
            'mark',
            'generateNo',
          ];
        } else {
          console.log('城矿公司->当前供应商不支持');
          this.hiddenList = [
            'identityNo',
            'bankAccount',
            'identityNo',
            'bankAccount',
            // 'customerName',
            'generateNo',
            // 'generateSalesCompanyName',
            // 'generateSalesDepartmentName',
            // 'recyclingCompanyFileNo',
            'recyclingCompanyName',
            // 'platformCompanyFileNo',
            'platformCompanyName',
            'mark',
          ];
        }
      } else if (COMPANY_CODE2.includes(companyCode)) {
        console.log(supplierType, this.fileType, '====哈哈哈=>>');
        // demo公司只负载投送人
        if (supplierType == DROP_OFF_PERSON && this.fileType == 'contract') {
          console.log('demo公司->合同投送人表单');
          // 合同的时候投送人
          this.hiddenList = [
            'overShippedPercentage',
            'shortShippedPercentage',
            'isDefault',
            'contractSalesmanNo',
            'replyInvoiceDate',
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'creditPercent',
            'lastestPayMoneyDay',
            'lastestReceiveProductDay',
            'businessType',
            'isFixedPrice',
            'pricingRule',
            'warrantyClause',
            'performanceBond',
            'performanceBondPayMethodCode',
            'shortShippedPercentage',
            'overShippedPercentage',
            // 'customerName',
            'contractName',
            'generateNo',
            // 'generateSalesCompanyName',
            // 'generateSalesDepartmentName',
            // 'recyclingCompanyFileNo',
            'recyclingCompanyName',
            // 'platformCompanyFileNo',
            'platformCompanyName',
            'mark',
          ];
        } else if (supplierType == DROP_OFF_PERSON && this.fileType == 'agreement') {
          console.log('demo公司->协议投送人表单');
          // 协议的时候投送人
          this.hiddenList = [
            'purchaseQuantity',
            'overShippedPercentage',
            'shortShippedPercentage',
            'isDefault',
            'contractSalesmanNo',
            'externalContractNo',
            'replyInvoiceDate',
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'creditPercent',
            'lastestPayMoneyDay',
            'lastestReceiveProductDay',
            'businessType',
            'isPrepay',
            'generateNo',
            'creditAmount',
            'isFixedPrice',
            'pricingRule',
            'receiptMethod',
            'warrantyClause',
            'performanceBond',
            'performanceBondPayMethodCode',
            'shortShippedPercentage',
            'overShippedPercentage',
            'platformCompanyName',
            // 'platformCompanyFileNo',
            'recyclingCompanyName',
            // 'recyclingCompanyFileNo',
            // 'generateSalesCompanyName',
            // 'generateSalesDepartmentName',
            'contractName',
            // 'customerName',
            'mark',
          ];
        } else if (supplierType == WITHOUT_SETTLEMENT && this.fileType == 'agreement') {
          console.log('demo公司->外部协议表单');
          this.hiddenList = [
            'isFixedPrice',
            'pricingRule',
            'performanceBondPayMethodCode',
            'performanceBond',
            'warrantyClause',
            'overShippedPercentage',
            'shortShippedPercentage',
            'businessType',
            'identityNo',
            'bankAccount',
            // 'customerName',
            'generateNo',
            // 'generateSalesCompanyName',
            // 'generateSalesDepartmentName',
            // 'recyclingCompanyFileNo',
            'recyclingCompanyName',
            // 'platformCompanyFileNo',
            'platformCompanyName',
            'mark',
          ];
        } else if (supplierType == WITHOUT_SETTLEMENT && this.fileType == 'contract') {
          console.log('demo公司->外部合同表单');
          this.hiddenList = [
            'isFixedPrice',
            'pricingRule',
            'performanceBondPayMethodCode',
            'performanceBond',
            'warrantyClause',
            'overShippedPercentage',
            'shortShippedPercentage',
            'businessType',
            'identityNo',
            'bankAccount',
            // 'customerName',
            'generateNo',
            // 'generateSalesCompanyName',
            // 'generateSalesDepartmentName',
            // 'recyclingCompanyFileNo',
            'recyclingCompanyName',
            // 'platformCompanyFileNo',
            'platformCompanyName',
            'mark',
          ];
        } else {
          console.log('当前属于demo公司下面的供应商不支持,走正常逻辑');
          this.hiddenList = [
            'isFixedPrice',
            'pricingRule',
            'performanceBondPayMethodCode',
            'performanceBond',
            'warrantyClause',
            'overShippedPercentage',
            'shortShippedPercentage',
            'businessType',
            // 'customerName',
            'generateNo',
            // 'generateSalesCompanyName',
            // 'generateSalesDepartmentName',
            // 'recyclingCompanyFileNo',
            'recyclingCompanyName',
            // 'platformCompanyFileNo',
            'platformCompanyName',
            'mark',
          ];
        }
      } else {
        console.log('当前公司不支持,走正常逻辑判断(外部结算)');
        const baseFieldList = [
          'identityNo',
          'bankAccount',
          'identityNo',
          'bankAccount',
          // 'customerName',
          'generateNo',
          // 'generateSalesCompanyName',
          // 'generateSalesDepartmentName',
          // 'recyclingCompanyFileNo',
          'recyclingCompanyName',
          // 'platformCompanyFileNo',
          'platformCompanyName',
          'mark',
          'isFixedPrice',
        ];
        this.hiddenList = baseFieldList;
        // if (isHiddenGenerateField) {
        //   this.hiddenList = [...baseFieldList, ...this.generateField];
        // } else {
        //   this.hiddenList = baseFieldList;
        // }
        // // 创建的时候默认勾选是否生成销售合同
        // if (this.isCreateStatus) {
        //   this.isCreateStatus = false;
        //   this.baseFormData = {
        //     ...this.baseFormData,
        //     isGenerateSales: true,
        //   };
        // }
        // this.isDisabledGenerateSales = false;
      }
    },
  },
};
